import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import GoalsModel, { goalTypes } from "../models/GoalsModel";
import SelectGoalType from "./SelectGoalType";
import eventBus from "../eventBus";

export const AddGoal = ({ goals }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [goalName, setGoalName] = useState("");
  const [goalDuration, setGoalDuration] = useState(5);
  const [goalType, setGoalType] = useState("weekly");

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const handleSubmit = () => {
    if (goalName.length == 0) return;
    GoalsModel.add(goalName, goalDuration, goals.length, goalType);
    setGoalName("");
    setGoalDuration(0);
    setGoalType("weekly"); // Optionally reset to default type
    closeDialog(); // Close dialog after submission

    eventBus.dispatch("refreshGoals")
  };

  return (
    <div className="fixed right-4 bottom-4">
      <button
        onClick={openDialog}
        className="flex items-center justify-center w-10 h-10 bg-indigo-600 rounded-full hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <PlusIcon className="w-6 h-6 text-white" aria-hidden="true" />
      </button>

      <Transition.Root show={isDialogOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeDialog}>
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6">
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={closeDialog}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                      {/* Goal form inputs */}
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900 mb-4"
                      >
                        Add New Goal
                      </Dialog.Title>
                      <div className="mt-2">
                        <div className="relative mb-4">
                          <label
                            htmlFor="name"
                            className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
                          >
                            Goal Name
                          </label>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            className="block w-[100%] rounded-md py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-4 border border-gray-300"
                            onChange={(e) => setGoalName(e.target.value)}
                            value={goalName}
                          />
                        </div>
                        <div className="relative mb-4">
                          <label
                            htmlFor="name"
                            className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-900"
                          >
                            Duration (min)
                          </label>
                          <input
                            type="number"
                            name="name"
                            id="name"
                            className="block w-[100%] rounded-md py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pl-4 border border-gray-300"
                            onChange={(e) =>
                              setGoalDuration(parseInt(e.target.value))
                            }
                            value={goalDuration}
                          />
                        </div>

                        <SelectGoalType
                          setSearchGoalType={setGoalType}
                          defaultGoalType={goalType}
                        />
                      </div>
                      <div className="mt-[150px]">
                        <button
                          type="button"
                          className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          onClick={handleSubmit}
                        >
                          Add Goal
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};
